import Swiper from "swiper";
import { Navigation } from 'swiper/modules';
import "swiper/css";

// timeline
$("body").on("imageCarouselReady", function () {
    const swipers = document.querySelectorAll(
        ".images-carousel-inner .swiper"
    );

    swipers.forEach((el, index) => {
        el.classList.add(`slider-timeline-${index}`);

        const swiper = new Swiper(`.slider-timeline-${index}`, {
            modules: [Navigation],
            slidesPerView: 1,
            slidesPerGroup: 1,
            // slidesPerGroup: 1,
            // speed: 600,
            autoHeight: true,
            // centeredSlides: true,
            navigation: {
                prevEl: `.images-carousel-inner .slider-control.prev`,
                nextEl: `.images-carousel-inner .slider-control.next`,
            },
            on: {
                init: function () {
                    // updateControlLabels(this, 0);
                },
                slideChange: function () {
                    // updateControlLabels(this, this.activeIndex);
                    // updateNavigationPosition(this, this.activeIndex);
                    // updateTimelineContent(this.activeIndex);
                },
            },
            breakpoints: {
                // 576: {
                //     slidesPerView: 2,
                //     slidesPerGroup: 1,
                //     spaceBetween: 20,
                // },
                // 768: {
                //     slidesPerView: 3,
                //     slidesPerGroup: 1,
                //     spaceBetween: 30,
                // },
            },
        });
    });
});

if($('.wp-block-pulp-image-carousel').length) {
    $(document).ready(function () {
        $('body').trigger('imageCarouselReady');
    });
}
